import * as types from './types';

const getFormValues = payload => {
  const module = payload.module ? `/MODULE_${payload.module}/${payload.postingId}` : '';
  return {
    type: types.GET_FORM_VALUES,
    meta: {
      async: true,
      blocking: false,
      api: 'publicador',
      path: `/publicador/api/v1/postings/${payload.step}${module}`,
      method: 'GET'
    }
  };
};

const getPropertyTypes = () => ({
  type: types.GET_PROPERTY_TYPES,
  meta: {
    async: true,
    blocking: false,
    api: 'publicador',
    path: '/publicador/api/v1/realestatetypes',
    method: 'GET'
  }
});

const getPropertySubTypes = propertyTypeId => ({
  type: types.GET_PROPERTY_SUBTYPES,
  meta: {
    async: true,
    blocking: false,
    api: 'publicador',
    path: `/publicador/api/v1/realestatetypes/${propertyTypeId}/subtypes`,
    method: 'GET'
  }
});

const setRedirectFromAppraisal = () => ({
  type: types.SET_REDIRECT_FROM_APPRAISAL
});

const setPropertyType = payload => ({
  type: types.SET_PROPERTY_TYPE,
  payload
});

const setPropertySubType = payload => ({
  type: types.SET_PROPERTY_SUBTYPE,
  payload
});

const setOperationType = payload => ({
  type: types.SET_OPERATION_TYPE,
  payload
});

const setEditValues = payload => ({
  type: types.SET_EDIT_VALUES,
  payload
});

const setDisabledBranch = payload => ({
  type: types.SET_DISABLED_BRANCH,
  payload
});

const cleanValues = () => ({
  type: types.CLEAN_VALUES
});

export {
  getPropertyTypes,
  getPropertySubTypes,
  setPropertyType,
  setPropertySubType,
  setOperationType,
  setEditValues,
  getFormValues,
  setDisabledBranch,
  cleanValues,
  setRedirectFromAppraisal
};
